import { reporterContextSnapshot, reportMessage } from "./sentry-reporter";

export const LONG_TASK_ENTRY_TYPE = "longtask";
export const LONG_TASK_REPORT_THRESHOLD_MS = 2_000;
export const LONG_TASK_STALL_MESSAGE = "The add-in's main thread stalled";

interface LongTaskEntryList {
    getEntries(): readonly PerformanceEntry[];
}

let activeLongTaskObserver: PerformanceObserver | null = null;

function reportLongTask(longTaskEntry: PerformanceEntry): void {
    if (longTaskEntry.duration < LONG_TASK_REPORT_THRESHOLD_MS) return;
    reportMessage(LONG_TASK_STALL_MESSAGE, {
        level: "warning",
        extra: {
            component: "long_task_report",
            durationMs: Math.round(longTaskEntry.duration),
            startTimeMs: Math.round(longTaskEntry.startTime),
            page: reporterContextSnapshot().page,
        },
    });
}

export function startLongTaskReport(observerConstructor: typeof PerformanceObserver | null = globalThis.PerformanceObserver ?? null): boolean {
    if (activeLongTaskObserver !== null) return true;
    if (observerConstructor === null) return false;
    if (!observerConstructor.supportedEntryTypes?.includes(LONG_TASK_ENTRY_TYPE)) return false;
    const longTaskObserver = new observerConstructor((entryList: LongTaskEntryList) => {
        for (const longTaskEntry of entryList.getEntries()) reportLongTask(longTaskEntry);
    });
    longTaskObserver.observe({ entryTypes: [LONG_TASK_ENTRY_TYPE] });
    activeLongTaskObserver = longTaskObserver;
    return true;
}

export function stopLongTaskReport(): void {
    activeLongTaskObserver?.disconnect();
    activeLongTaskObserver = null;
}
